import { request } from '@/shared/api/request'

export const returnResultAuth = (payload) => {
	return request({ url: `/selftest/auth/save/returnResult`, method: 'POST', data: payload })
}
